import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getDepartment as onGetDepartments, addNewDepartment as onAddNewDepartment, updateDepartment as onUpdateDepartment, deleteDepartment as onDeleteDepartment, getDepartmentLoading, resetDepartmentState } from "../../../store/department/action";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import { useRef } from "react";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const Department = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clientLoading, clients, departments, isDepartmentCreated, isDepartmentSuccess, loading, error, companies, companyLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    departments: state.Department.departments,
    isDepartmentCreated: state.Department.isDepartmentCreated,
    isDepartmentSuccess: state.Department.isDepartmentSuccess,
    loading: state.Department.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.Department.error,
  }));

  const [departmentList, setDepartmentList] = useState([]);
  const [department, setDepartment] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [parentList, setParentList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [companyName, setCompanyName] = useState({});

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const [printDoc, setPrintDoc] = useState([]);

  const onClickDelete = (department) => {
    setDepartment(department);
    setDeleteModal(true);
  };

  const handleDeleteDepartment = () => {
    if (department) {
      dispatch(onDeleteDepartment(department));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredDepartments = departments;
      if (type !== "all") {
        filteredDepartments = departments.filter((department) => department.department_status.name === type);
      }
      setDepartmentList(filteredDepartments);
    }
  };

  useEffect(() => {
    if (companySelected && companySelected.value) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(resetDepartmentState());
      dispatch(onGetDepartments({ companyId: companySelected?.value ?? "" }));
    }
  }, [companySelected]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    departments.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (departments.length > 0) {
      setParentList(data);
    }
  }, [departments]);

  useEffect(() => {
    if (!isEmpty(departments)) {
      let filteredDepartments = departments;
      if (activeTypeTab !== "all") {
        filteredDepartments = departments.filter((department) => department.department_status.name === activeTypeTab);
      }

      setDepartmentList(filteredDepartments.map((el) => ({ ...el, isChecked: false })));
    }
    else{
      setDepartmentList([]);
    }
  }, [departments]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "code",
        label: "Kode",
        isSelected: true,
        data: [],
      },
      {
        id: "par_dep",
        label: "Induk Departemen",
        isSelected: true,
        data: [],
      },
      {
        id: "department_company",
        label: "Perusahaan",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (departmentList.length > 0) {
      departmentList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "par_dep" || doc.id === "department_company") {
                doc.data.push(value?.name ?? "-");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [departmentList]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
  }, [dispatch, modal]);

  const handleDepartmentClick = useCallback(
    (arg) => {
      const data = arg;
      setDepartment({
        id: data.id,
        name: data.name,
        code: data.code,
        description: data.description,
        client: data.department_client && {
          label: data.department_client ? data.department_client.name : "",
          value: data.department_client ? data.department_client.id : "",
        },
        company: data.department_company && {
          label: data.department_company ? data.department_company.name : "",
          value: data.department_company ? data.department_company.id : "",
        },
        parent: data.par_dep && {
          label: data.par_dep ? data.par_dep.name : "",
          value: data.par_dep ? data.par_dep.id : "",
        },
        status: data.department_status && {
          label: data.department_status ? data.department_status.name : "",
          value: data.department_status ? data.department_status.id : "",
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle, userType, departments]
  );

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: (department && department.name) ?? "",
      code: (department && department.code) ?? "",
      status: (department && department.status) || "1",
      description: (department && department.description) ?? "",
      client: (department && department.client) || clientSelected,
      company: (department && department.company) || companySelected,
      parent: (department && department.parent) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Department Name").nullable(true),
      code: Yup.string().required("Please Enter Department Code").nullable(true),
      company: Yup.object().required("Please Pick Company").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getDepartmentLoading());
      if (isEdit) {
        const updateDepartment = {
          id: department ? department.id : 0,
          name: values.name,
          code: values.code,
          description: values.description,
          statusId: values.status.value,
          clientId: values.client.value,
          companyId: values.company.value,
          parentId: values.parent ? values.parent.value : null,
        };
        dispatch(onUpdateDepartment(updateDepartment));
        validation.resetForm();
      } else {
        const newDepartment = {
          name: values.name,
          code: values.code,
          description: values.description,
          statusId: values.status.value,
          clientId: values.client.value,
          companyId: values.company.value,
          parentId: values.parent ? values.parent.value : null,
        };
        dispatch(onAddNewDepartment(newDepartment));
        validation.resetForm();
      }
      toggle();
    },
  });

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteDepartment(element.value));
    });
    checkall.checked = false;
  };
  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = departmentList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setDepartmentList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = departmentList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setDepartmentList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateDepartment") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleDepartmentClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteDepartment") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Departemen",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Kode",
        accessor: "code",
        filterable: true,
      },
      {
        Header: "Induk Departemen",
        accessor: "par_dep.name",
        filterable: true,
      },
      {
        Header: "Perusahaan",
        accessor: "department_company.name",
        filterable: true,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: `Status`,
        accessor: "billing_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.row.original.statusId) {
            case 1:
              return <span className="badge text-uppercase badge-soft-warning">DRAFT</span>;
            case 2:
              return <span className="badge text-uppercase badge-soft-info">ACTIVE</span>;
            default:
              return <span className="badge text-uppercase badge-soft-danger">INACTIVE</span>;
          }
        },
      },
    ],
    [departmentList, handleDepartmentClick, userType, userRole, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(new Date(time), "YYYY/MM/DD").format("HH:mm");
  };

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = departmentList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setDepartmentList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => departmentList, [departmentList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleDepartmentStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetDepartments(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setDepartmentList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(resetDepartmentState());
    dispatch(onGetDepartments({ companyId: companySelected?.value ?? "" }));
  };

  document.title = "Departemen | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={departmentList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteDepartment} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Organisasi" pageTitle="Departemen" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createDepartment") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={printDoc} />
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteDepartment") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Hapus
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="departmentList">
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> SEMUA DEPARTEMEN
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <Select
                                value={statusActive}
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  handleDepartmentStatus(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"
                              ></Select>
                            </div>
                          </Col>

                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Departemen" : "Tambah Departemen"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                validation.setFieldValue("client", e);
                              }}
                              options={clientList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                dispatch(setBranchSelect(null));
                                dispatch(setCompanySelect(e));
                                validation.setFieldValue("company", e);
                                validation.setFieldValue("parent", "");
                              }}
                              options={companyList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Nama Departemen
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama Departemen" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="code-field" className="form-label">
                              Kode Departemen
                            </Label>
                            <Input name="code" id="code-field" className="form-control" placeholder="Isi Kode Departemen" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.code ?? ""} invalid={validation.touched.code && validation.errors.code ? true : false} />
                            {validation.touched.code && validation.errors.code ? <FormFeedback type="invalid">{validation.errors.code}</FormFeedback> : null}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="parent-field" className="form-label">
                              Induk Departemen
                            </Label>
                            <Select
                              name="parent"
                              value={validation.values.parent}
                              placeholder="Pilih Induk Departemen"
                              onChange={(e) => {
                                validation.setFieldValue("parent", e);
                              }}
                              options={parentList}
                            ></Select>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="active-status" className="form-label">
                              Status
                            </Label>
                            <Select
                              name="status"
                              value={validation.values.status}
                              placeholder="Pilih Status"
                              onChange={(e) => {
                                validation.setFieldValue("status", e);
                              }}
                              options={statusActiveData}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="des-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="des-field" className="form-control" rows={6} placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            toggle();
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Simpan" : "Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Department;
